export default "__VITE_ASSET__CLjdY61L__"